<template>
  <div class="grid-container full container">
    <div class="grid-x page-contents-8" >

      <div class=" small-12 medium-6 cell left-column">
        <h2>Attraction & Development</h2>

        <p class="tag">
          Hire the UK's best early talent.
        </p>
        <p>&nbsp;</p>

        <rare-standard-button
          class="contactButton show-for-small-only"
          :tabIndex="16"
          :active="'true'"
          :buttonText="'Learn more'"
          :height="'40px'"
          :width="'200px'"
          :fontColor="'#ffffff'"
          :fontSize="'14px'"
          @clicked="$router.push('/products/attraction-and-development')"
        />
        <rare-standard-button
          class="contactButton show-for-medium"
          :tabIndex="16"
          :active="'true'"
          :buttonText="'Learn more'"
          :height="'75px'"
          :width="'316px'"
          :fontColor="'#ffffff'"
          :fontSize="'20px'"
          @clicked="$router.push('/products/attraction-and-development')"
        />
      </div>

      <div class="small-12 medium-6 cell right-column small-text-center">
        <div class="graphicContainer">
          <img
            class="appsIntsHiresGraphic"
            src="@/assets/img/icons/apps-ints-hire.png"
            alt="Attraction and Development, Contextual Recruitment Info-graphic." />
          <p class="graphiclabel">For every five applications, two interviews, one hire</p>
        </div>
      </div>

    </div>
  </div>
</template>
<script>

import RareStandardButton from '@/components/atoms/RareWebButton';

export default {
  name: 'RareHomeProductsAttractionDevelopment',
  components: {
    'rare-standard-button': RareStandardButton,
  },
  methods: {
    openContactForm() {
      this.$root.$emit('updateContactForm', true);
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .container {
    border-bottom: 1px solid $border;
  }

  h2, h1 {
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
  }

  @media only screen and (max-width: 640px) {
    .right-column {
      padding-right: 0;
    }

    .graphicContainer {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    h2, h1 {
      font-size: 28px;
      line-height: 1.43;
      margin: 28px 0 16px 0;
      text-align: center;
    }

    p.tag {
      text-align: center;
    }

    .appsIntsHiresGraphic {
      margin: 0 auto 40px auto;
      max-height: 271px;
    }

    .contactButton {
      margin: -20px auto 36px auto;
    }

    .standardcase {
      text-align: center;
    }

    .graphiclabel {
      font-size: 14px;
      font-weight: 300;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.71;
      letter-spacing: 2px;
      text-align: center;
      margin-top: -20px;
      margin-bottom: 25px;
      max-width: 271px;
      margin-left: auto;
      margin-right: auto;
      text-transform: uppercase;
    }

  }

  @media only screen and (min-width: 641px) {
    .right-column {
      padding-left: 20px;
      max-width: 700px;
      // position: relative;
    }

    .left-column {
    }

    .graphicContainer {
      // position: absolute;
      // bottom: 0;
      margin: 48px 0px 0px 100px;
    }

    h2, h1 {
      font-size: 56px;
      line-height: 1.29;
      margin: 122px 0 23px 0;
      text-align: left;
    }

    .appsIntsHiresGraphic {
      max-height: 448px;
    }

    .contactButton {
      margin: 8px 0 96px 0;
    }

    .graphiclabel {
      font-size: 18px;
      font-weight: 300;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.2;
      letter-spacing: 2px;
      text-align: center;
      margin: 24px auto 35px auto;
      max-width: 376px;
      text-transform: uppercase;
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/homeProducts/components/RareHomeProductsAttractionDevelopment.vue